import { FileType, SortingOption } from "../../features/insights-cube/insights-cube.enum";

export namespace Constant {
    
    export const ACCEPTED_IMAGE_TYPE = ".jpeg, .jpg, .png";
    export const ACCEPTED_VIDEO_TYPE = ".mp4";
    export const ACCEPTED_AUDIO_TYPE = ".mp3, .mpeg, .mp4";
    export const ACCEPTED_TRANSCRIPT_TYPE = ".txt, .vtt, .plain, .docx, .vnd.openxmlformats-officedocument.wordprocessingml.document";
    export const PROFILE_PIC_MAX_SIZE = 2 * 1024 * 1024; // 2MB
    export const MAX_SECTION_ALLOWED = 100;
    export const INSIGHT_QUBE_ACCEPTED_FILE = ".pdf, .pptx, .xls, .xlsx, .docx, .plain, .doc, .csv, .txt, .md, .vnd.openxmlformats-officedocument.wordprocessingml.document, .vnd.openxmlformats-officedocument.presentationml.presentation, .msword, .vnd.openxmlformats-officedocument.spreadsheetml.sheet,  .zip,  '.application/zip', .application/x-zip-compressed, .x-zip-compressed";

    export const EMOTIONS = [
        'engagement',
        'neutral',
        // 'joy',
        'happiness',
        'surprise',
        'anger',
        'fear',
        'sadness',
        'disgust',
        'confused',
        'valence'
        // 'smile' hiding smile as per ISPQL-173
        // 'contempt',
    ];
    export const DEFAULT_ACTIVE_EMOTIONS = ['engagement', 'happiness', 'anger'];
    export const EMOTION_COLORS: any = {
        Engagement: "#EF476F",
        EngagementLight: "#f6a8b9",
        Joy: "#FFCD33",
        JoyLight: "#fee6a0",
        Neutral: "#91E190",
        NeutralLight: "#c9f0c8",
        Surprise: "#796BD3",
        SurpriseLight: "#beb8e9",
        Fear: "#1D2A4A",
        FearLight: "#979caa",
        Anger: "#F24E2A",
        AngerLight: "#f8ab9d",
        Sadness: "#BE7C48",
        SadnessLight: "#dfbfa9",
        Confusion: "#790252",
        ConfusionLight: "#CFA8C3",
        Contempt: "#74D0C9",
        ContemptLight: "#bbe7e4",
        Smile: "#FFCD33",
        SmileLight: "#fee6a0",
        Disgust: "#74D0C9",
        DisgustLight: "#bbe7e4",
        Happiness: "#FFCD33",
        HappinessLight: "#fee6a0",
        Confused: "#790252",
        ConfusedLight: "#CFA8C3",
        Valence: "#3b093a",
    }
    
    export const GRAPH_COLOR_PICKER_CHOICES: any = [
        "#8aaae5", // Periwinkle
        "#ea738d", // Salmon
        "#cc313d", // Crimson
        "#e3b448", // Amber
        "#97bc62", // Lime Green
        "#8a307f", // Plum
        "#aa96da" // Lavender
    ]

    export const GRAPH_COLORS: any = [
        "#b5b34d", // Muted Yellow Green
        "#006db0", // Royale Blue
        "#569eb4", // Dense Sky Blue
        "#f6e08a", // Beige Pale Yellow
        "#86d7b6", // Mint Green
        "#40E0D0", // Turquoise
        "#FF4500", // Orange Red
        "#87CEEB", // Sky Blue
        "#77DD77", // Pastel Green
        "#DA70D6", // Orchid
        "#FFD700", // Gold
        "#FFA07A", // Light Salmon
        "#FF6B6B", // Red
        "#FF69B4", // Hot Pink
        "#98FB98", // Pale Green
    ]

    export const WORD_CLOUD_DEFAULT_COLORS = [
        '#0A4486',
        '#b7ba14',
        '#285722',
    ]

    export const STATUS_COLOUR = {
        NotStarted: 'lightgray',
        Running: "#FFDA61",
        Completed: "lightgreen",
        ProcessingError: "red",
        InstructionMissing: "lightgray"
    }

    export const NEW_REPORT_FEATURE_DEPLOYMENT_DATE = "2025-06-19";

    export const agreementPDFUrl = {
        pp : "user/get_policy_doc/lb_privacy_policy.pdf",
        cookie: "user/get_policy_doc/lb_cookie_policy.pdf",
        tnc:"user/get_policy_doc/lb_terms_and_condition.pdf",
        msa: "user/get_policy_doc/lb_msa_policy.pdf",
    }
}
export const NumberOfSecondsBeforeRedirect = 5;

export const maxAllowedStimuli = 100;

export const UNSAFE_PROMPT_ALLOWED = 5;

export const FILTER_OPTION = [
      {
        name: 'Created - Descending',
        value: SortingOption.CreatedOnDesc
      },
      {
        name: 'Created - Ascending',
        value: SortingOption.CreatedOnAsc
      },
      {
        name: 'Directory Name (A-Z)',
        value: SortingOption.DirNameAToZ
      },
      {
        name: 'Directory Name (Z-A)',
        value: SortingOption.DirNameZToA
      }
    ]

export const FILTER_OPTION_BY_FILETYPE = [
      {
        name: 'All Files',
        value: 'ALLFILES',
        visiable: true
      },
      {
        name: 'Sub Folder',
        value: FileType.Directory,
        visiable: true
      },
      {
        name: 'PDF',
        value: FileType.Pdf,
        visiable: true
      },
      {
        name: 'PPT(X)',
        value: FileType.Pptx,
        visiable: true
      },
      {
        name: 'XLS(X)',
        value: FileType.Xls,
        visiable: true
      },
      {
        name: 'DOC(X)',
        value: FileType.Doc,
        visiable: true
      },
      {
        name: 'CSV',
        value: FileType.Csv,
        visiable: true
      },
      {
        name: 'MD',
        value: FileType.Md,
        visiable: true
      },
      {
        name: 'TXT',
        value: FileType.Txt,
        visiable: true
      }
    ]